"use client";

import { useEffect } from "react";
import { loadRuntimeConfig } from "@/lib/runtime-config";

export function RuntimeConfigBootstrap() {
  useEffect(() => {
    void loadRuntimeConfig();
  }, []);

  return null;
}
